import React from 'react';

import { getArticles, deletePages, updateArticle, getArticle, getBlocks } from './../../Services/Api.service';
import { string, object } from 'yup';
import { translate } from '../../../Services/translation';

export const articlesModel = {
    root: 'articles',
    item: translate('coptikk.adminportal.article'),
    title: translate('coptikk.adminportal.articles'),
    systemId: "pageSystemId",
    requestPostData: updateArticle,
    requestBlockData: getBlocks,
    requestGetItem: getArticle,
    getData: getArticles,
    deleteRequest: deletePages,
    canPublish: true,
    forbidShowBlockAction: true,
    headers: [{
        headerName: "authorName",
        label: translate('coptikk.adminportal.article.authorname'),
        typeName: "String",
        isHiddenInIndex: true,
        isHiddenInForm: true,
        isDisabled: true
    }, {
        headerName: "title",
        label: translate('coptikk.adminportal.article.title'),
        typeName: "String",
        isHiddenInIndex: false,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "publishedInformationText",
        label: translate('coptikk.adminportal.article.publishinfo'),
        typeName: "String",
        isHiddenInIndex: false,
        isHiddenInForm: true,
        isDisabled: false
    },{
        headerName: "articleDate",
        label: translate('coptikk.adminportal.article.date'),
        typeName: "Date",
        isHiddenInIndex: true,
        isHiddenInForm: true,
        isDisabled: false
    }, {
        headerName: "categoryTitle",
        label: translate('coptikk.adminportal.article.categorytitle'),
        typeName: "String",
        isHiddenInIndex: true,
        isHiddenInForm: true,
        isDisabled: false
    }, {
        headerName: "categoryUrl",
        label: translate('coptikk.adminportal.article.categoryurl'),
        typeName: "Url",
        isHiddenInIndex: false,
        isHiddenInForm: true,
        isDisabled: false
    }, {
        headerName: "parentPageId",
        label: translate('coptikk.adminportal.article.categorytitle'),
        typeName: "Select",
        selectOptions: {
            endpoint: "/api/adminportal/article/Categories",
            id: "pageSystemId",
            name: "name"
        },

        isHiddenInIndex: true,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "articleImage",
        label: translate('coptikk.adminportal.article.image'),
        typeName: "Image",
        isHiddenInIndex: true,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "introduction",
        label: translate('coptikk.adminportal.article.introduction'),
        typeName: "Editor",
        isHiddenInIndex: true,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "text",
        label: translate('coptikk.adminportal.article.text'),
        typeName: "Editor",
        isHiddenInIndex: true,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "updatedDate",
        label: translate('coptikk.adminportal.article.updateddate'),
        typeName: "Date",
        isHiddenInIndex: false,
        isHiddenInForm: true,
        isDisabled: false
    }, {
        headerName: "url",
        label: translate('coptikk.adminportal.article.url'),
        typeName: "Url",
        isHiddenInIndex: false,
        isHiddenInForm: true,
        isDisabled: false
    },
    {
        headerName: "sortIndex",
        label: translate('coptikk.adminportal.article.sortindex'),
        typeName: "String",
        isHiddenInIndex: false,
        isHiddenInForm: false,
        isDisabled: false
    }],
    validation: object().shape({
        title: string().required(translate(`validation.required`)),
        sortIndex: string().transform((value) => value != null ? value.replace(/\s/g, "") : value).matches(/^[0-9]+$/, "Must be only digits").notRequired().nullable().transform((value) => !!value ? value : null),
    })
}